import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import DynamicForm from "../../../Components/Common/DynamicForm/DynamicForm";
import styles from "./master.module.css";
import SettingComponent from "../../../Components/Common/DynamicForm/SettingComponent";

export default function SettingMaster({meta}) {
  const [settingsName, setSettingsName] = useState("");
  const [settings, setSettings] = useState([
    { name: "", description: "", inputType: null },
  ]);

  const inputTypes = [
    {
      label: "Text",
      type: "text",
      attributes: {
        text: [          
          "title",
          "pattern",
        ],
        number: ["maxlength", "minlength", "size"],
        boolean: [
          "required",
          "readonly",
          "disabled",
          "spellcheck",
        ],
      },
    },
    {
      label: "Number",
      type: "number",
      attributes: {
        text: ["title"],
        number: ["value", "min", "max"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Date",
      type: "date",
      attributes: {
        text: ["title"],
        date: ["value", "min", "max"],
        boolean: ["required", "readonly", "disabled", "autofocus"],
      },
    },
    {
      label: "Time",
      type: "time",
      attributes: {
        text: ["title"],
        time: ["value", "min", "max"],
        number: ["step"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Range",
      type: "range",
      attributes: {
        text: ["title"],
        number: ["value", "min", "max", "step"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Email",
      type: "email",
      attributes: {
        text: [          
          "title",
          "pattern",
        ],
        number: ["maxlength", "minlength", "size"],
        boolean: [
          "required",
          "readonly",
          "disabled",
          "multiple",
        ],
      },
    },
    {
      label: "Boolean",
      type: "checkbox",
      attributes: {
        text: ["title"],
        boolean: ["required", "readonly", "disabled","checked"],
      },
    },
    {
      label: "Radio",
      type: "radio",
      attributes: {
        text: ["title"],
        boolean: ["required", "readonly", "disabled", "checked"],
      },
    },
    {
      label: "Textarea",
      type: "textarea",
      attributes: {
        text: [         
          "title",
          "pattern",
          "wrap",
        ],
        number: ["maxlength", "minlength", "rows", "cols"],
        boolean: [
          "required",
          "readonly",
          "disabled",         
          "spellcheck",
        ],
      },
    },
    {
      label: "Dropdown",
      type: "dropdown",
      attributes: {
        text: [
          "options",          
        ],
        number: [],
        boolean: ["required", "readonly", "disabled", "multiple"],
      },
    },
  ];

  const handleInputChange = (index, field, value) => {
    const updatedSettings = [...settings];
    updatedSettings[index][field] = value;
    setSettings(updatedSettings);
  };

  const addNewSetting = () => {
    setSettings([...settings, { name: "", description: "", inputType: null }]);
  };

  const onEditLabel = (e) => {
    // console.log("Editable Label", e);
  };

  const AttributeOnChange = (i, name, value) => {
    // console.log("index", i);
    // console.log("name", name);
    // console.log("value", value);
    const attrib = {};
    attrib[name] = value;
    setSettings((prevSelectedAttributes)=>{
      // console.log('prevSelectedAttributes',prevSelectedAttributes);
      
      const updatedSettings = [...prevSelectedAttributes];
      if (updatedSettings[i].selected_attribute) {
        prevSelectedAttributes = updatedSettings[i]["selected_attribute"];
      } else {
        prevSelectedAttributes = updatedSettings[i].selected_attribute;
      }
      const updatedSelectedAttribute = { ...prevSelectedAttributes, ...attrib };
      updatedSettings[i]["selected_attribute"] = updatedSelectedAttribute;

      return updatedSettings
    })
    // setSettings(updatedSettings);
  };

  const settingsHandlechange=(e)=>{

  }
 const [payload,setPayload]=useState()
  const handleSubmit=(e)=>{    
    e.preventDefault()
    setPayload({
      settingsName,
      settings
    })
    // console.log("Payload",payload);
  }

  return (
    <div className="mx-6 my-6 mx-1">
      <CommonLayout />
      <div className="n-card">
        <h1 >Create Form Template</h1>
        <form onSubmit={handleSubmit} className="d-flex flex-column">
          <div className="my-1">
            <label className="form-label" htmlFor="">
              Template name
            </label>
            <input
              onChange={(e) => setSettingsName(e.target.value)}
              value={settingsName}
              className="form-input"
              type="text"
            />
          </div>
          {settings.map((setting, index) => (
            <>
              <div key={index} className="border-primary p1 my-1">
                <div class={styles.halfCircle}>
                  <h1>{index + 1}</h1>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-1">
                  <div className="flex-1">
                    <label
                      className="form-label"
                      htmlFor={`setting-name-${index}`}
                    >
                      Field Name
                    </label>
                    <input
                      className="form-input"
                      type="text"
                      id={`setting-name-${index}`}
                      value={setting.name}
                      onChange={(e) =>
                        handleInputChange(index, "name", e.target.value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <label
                      className="form-label"
                      htmlFor={`setting-description-${index}`}
                    >
                      Field Description
                    </label>
                    <input
                      className="form-input"
                      type="text"
                      id={`setting-description-${index}`}
                      value={setting.description}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <label
                      className="form-label"
                      htmlFor={`input-type-${index}`}
                    >
                      Input Type
                    </label>
                    <Dropdown
                      value={setting.inputType}
                      options={inputTypes}
                      onChange={(e) =>
                        handleInputChange(index, "inputType", e.value)
                      }
                      optionLabel="label"
                      placeholder="Select Input Type"
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        height: "1.9rem",
                      }}
                      className="w-full"
                      required
                    />
                  </div>
                </div>
                {settings[index].inputType !== null ? (
                  <DynamicForm
                    master="true"
                    AttributeOnChange={AttributeOnChange}
                    onEditLabel={(e) => onEditLabel(e)}
                    index={index}
                    inputType={settings[index].inputType}
                  />
                ) : (
                  ""
                )}
              </div>
            </>
          ))}
          <div className="my-1">
            <button type="button" className="btn" onClick={addNewSetting}>
              +
            </button>
          </div>
          <div className="my-1">
            <button type="submit" className="btn">
              Save
            </button>
          </div>
        </form>
      </div>
      <div className="my-2 d-flex gap-1 " >
        {/* SettingName:{settingsName}
        <br />
        {JSON.stringify(settings)} */}
        {payload && <SettingComponent settingsHandlechange={settingsHandlechange} settingsName={payload.settingsName} settings={payload.settings} /> }
        
      </div>
    </div>
  );
}
